import { useState } from "react";

import { ProxyLocationTag } from "common/components/Proxy";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";
import { decodeProxyUrl } from "common/helpers/utils";
import type { CustomProxy } from "common/types";

import ProxyActionsDropdown from "./ProxyActionsDropdown";
import ProxyDialog from "./ProxyDialog";

type Action = "edit" | "delete";

export default function ProxiesDesktopTable({
  proxies,
}: {
  proxies: CustomProxy[];
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<Action>(null);
  const [selectedProxy, setSelectedProxy] = useState<CustomProxy>(null);

  return (
    <>
      <Table>
        <thead>
          <tr>
            <TableHead>Proxy name</TableHead>
            <TableHead>URL</TableHead>
            <TableHead>Authentication</TableHead>
            <TableHead>Location</TableHead>
            <TableHead />
          </tr>
        </thead>

        <tbody>
          {proxies.map((proxy) => {
            const { name, id, url, location, valid: isValid } = proxy;
            const { username, password, protocol, address } =
              decodeProxyUrl(url);

            const hasAuth = !!username && !!password;

            return (
              <TableRow key={id}>
                <TableCell className="text-sm-bold">{name}</TableCell>

                <TableCell>
                  {protocol}://{address}
                </TableCell>

                <TableCell>{hasAuth ? "***************" : "-"}</TableCell>

                <TableCell>
                  <ProxyLocationTag
                    location={
                      location && {
                        countryCode: location.countryISO,
                        name: location.city || location.country,
                      }
                    }
                    size="md"
                    isValid={isValid}
                  />
                </TableCell>

                <TableCell>
                  <ProxyActionsDropdown
                    openActionModal={(newAction) => {
                      setSelectedProxy(proxy);
                      setAction(newAction);
                      setIsOpen(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>

      {selectedProxy && (
        <ProxyDialog
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          action={action}
          proxy={selectedProxy}
        />
      )}
    </>
  );
}
